/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelAdditionalInfo64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelAdditionalInfo64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15Z"
            fill="currentColor"
          />
          <g>
            <path
              d="M32 27.75C32.6904 27.75 33.25 27.1904 33.25 26.5C33.25 25.8096 32.6904 25.25 32 25.25C31.3096 25.25 30.75 25.8096 30.75 26.5C30.75 27.1904 31.3096 27.75 32 27.75Z"
              fill="currentColor"
            />
            <path
              d="M32.5 30.5H30.5V31.5H32V38H33V31C33 30.7239 32.7761 30.5 32.5 30.5Z"
              fill="currentColor"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49 13H15C13.8954 13 13 13.8954 13 15V49C13 50.1046 13.8954 51 15 51H49C50.1046 51 51 50.1046 51 49V15C51 13.8954 50.1046 13 49 13ZM15 12C13.3431 12 12 13.3431 12 15V49C12 50.6569 13.3431 52 15 52H49C50.6569 52 52 50.6569 52 49V15C52 13.3431 50.6569 12 49 12H15Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelAdditionalInfo64Icon.tags = [
  'add',
  'info',
  'plus',
  'expand',
  'details',
];

AddPanelAdditionalInfo64Icon.category = '64x64 (Add panel)';

AddPanelAdditionalInfo64Icon.iconSize = 64;
